define('views/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-set',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // parent view
    'views/modules/calendar/animated-session/exercise/weight/weight-set',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-set.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // parent view
    VWeightExerciseSet,
    // templates
    TWeightBriefSet
) {

    var VWeightBriefSet = VWeightExerciseSet.extend({
        template: TWeightBriefSet,

        initialize: function(opt) {
            VWeightBriefSet.__super__.initialize.call(this, opt);
            _.extend(this.bindingSources, {
                user: User
            });
        },
    });

    return VWeightBriefSet;

});

